// extracted by mini-css-extract-plugin
export default {"modal":"documentFinalization_modal__YuOWM","buttons":"documentFinalization_buttons__uLaIy"};